import type { Command } from '../menu/types';
import { getCommandId } from '../grid/commands/utils';

export const PROFILE_PHOTO_COMMAND_ID = 'addchangeprofilephoto';
export const PROFILE_PHOTO_ANCHOR_FIELD = 'CrmRelationInitials';

const toPositiveInteger = (value: unknown): number | null => {
  const id = Number(value);
  return Number.isInteger(id) && id > 0 ? id : null;
};

export const getProfilePhotoRelationId = (
  values: Record<string, unknown>,
  parentId?: string
): number | null =>
  toPositiveInteger(values.Id) ??
  toPositiveInteger(values.CrmRelationId) ??
  toPositiveInteger(parentId);

export const getProfilePhotoInitials = (values: Record<string, unknown>): string =>
  typeof values.CrmRelationInitials === 'string' ? values.CrmRelationInitials.trim() : '';

export const isProfilePhotoCommand = (command: Command): boolean =>
  getCommandId(command) === PROFILE_PHOTO_COMMAND_ID;

export const getDetailFormActionCommands = (commands: Command[] | undefined): Command[] =>
  (commands ?? []).filter((command) => !isProfilePhotoCommand(command));
